import { connect } from 'react-redux';
import { formDelete, formStartNew } from '../../../actions';
import FormsPanel from './FormsPanel';

const mapStateToProps = ({ forms, formBuilder }) => ({
    forms: forms.existing,
    form: formBuilder.form,
});

const mapDispatchToProps = (dispatch) => ({
    onDelete: (form) => {
        dispatch(formDelete(form));
    },
    onStartNew: (name, formDefinition, callBack) => {
        dispatch(formStartNew({ name, formDefinition, callBack }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormsPanel);
